import styled from 'styled-components';
import { Input } from '../../../../../components/ds';

export const PasswordInput = styled(Input.Password)`
`;
